import React, { useContext } from "react";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { chageEstadoRouters } from "../../../../../../API/IT/Dispositivos/DispositivosRequest";

const RoutersScreen = ({
  routers,
  selected,
  setSelected,
  loading,
  setShowDialog,
  toast,
  estados,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          placeholder="Estados"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdRouter: item.IdRouter,
                  IdEstado: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdRouter: data.IdRouter,
                IdEstado: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName}?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdRouters = changes.map((item) => item.IdRouter);
                cambiarEstado(e.value.IdStatus, IdRouters.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdRouters) => {
    const result = await chageEstadoRouters({ IdStatus, IdRouters });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const colums = [
    {
      field: "IdRouter",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "IP",
      header: "IP",
      headerEn: "IP",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "SSID",
      header: "SSID",
      headerEn: "SSID",
      className: "large",
    },
    {
      field: "ClaveSSID",
      header: "Clave SSID",
      headerEn: "SSID Key",
      className: "large",
    },
    {
      field: "ClaveRouter",
      header: "Clave Router",
      headerEn: "Router Key",
      className: "large",
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Brand",
      className: "large",
    },
    {
      field: "modelo",
      header: "Modelo",
      headerEn: "Model",
      className: "large",
    },
    {
      field: "serie",
      header: "Serie",
      headerEn: "Serial",
      className: "large",
    },
    {
      field: "serie",
      header: "Serie",
      headerEn: "Serial",
      className: "large",
    },
    {
      field: "NombreActivo",
      header: "Activo",
      headerEn: "Asset",
      className: "large",
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "large",
    },
    {
      field: "Ubicacion",
      header: "Ubicación",
      headerEn: "Location",
      className: "XXXXlarge",
    },
    {
      header: "Estado",
      headerEn: "Status",
      frozen: true,
      alignFrozen: "right",
      field: "IdEstado",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: true,
    },
    {
      field: "IdRouter",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: routers,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
  };

  return (
    <div
      className="p-fluid"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <AgGrid table={table} />
    </div>
  );
};

export default RoutersScreen;
